/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * Transfer Transactions
 * PO Transactions

PO Transactions Viewer

API for printing labels using ZPL
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions } from '@tanstack/react-query';

import type { AccessError, LabelGeneratorError, PrintRequest } from '../model';
import { customInstanceNoFadcode } from '../mutator/customInstanceNoFadcode';
import type { ErrorType } from '../mutator/customInstanceNoFadcode';

/**
 * @summary Print label
 */
export const printLabelRoot = (printRequest: PrintRequest) => {
  return customInstanceNoFadcode<string>({
    url: `/label-generator/`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: printRequest,
  });
};

export const getPrintLabelRootMutationOptions = <
  TError = ErrorType<LabelGeneratorError | AccessError | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof printLabelRoot>>,
    TError,
    { data: PrintRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof printLabelRoot>>,
  TError,
  { data: PrintRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof printLabelRoot>>,
    { data: PrintRequest }
  > = (props) => {
    const { data } = props ?? {};

    return printLabelRoot(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PrintLabelRootMutationResult = NonNullable<Awaited<ReturnType<typeof printLabelRoot>>>;
export type PrintLabelRootMutationBody = PrintRequest;
export type PrintLabelRootMutationError = ErrorType<LabelGeneratorError | AccessError | void>;

/**
 * @summary Print label
 */
export const usePrintLabelRoot = <
  TError = ErrorType<LabelGeneratorError | AccessError | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof printLabelRoot>>,
    TError,
    { data: PrintRequest },
    TContext
  >;
}) => {
  const mutationOptions = getPrintLabelRootMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Print label (Back Office)
 */
export const printLabelBackOffice = (printRequest: PrintRequest) => {
  return customInstanceNoFadcode<string>({
    url: `/label-generator/back-office`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: printRequest,
  });
};

export const getPrintLabelBackOfficeMutationOptions = <
  TError = ErrorType<LabelGeneratorError | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof printLabelBackOffice>>,
    TError,
    { data: PrintRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof printLabelBackOffice>>,
  TError,
  { data: PrintRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof printLabelBackOffice>>,
    { data: PrintRequest }
  > = (props) => {
    const { data } = props ?? {};

    return printLabelBackOffice(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PrintLabelBackOfficeMutationResult = NonNullable<
  Awaited<ReturnType<typeof printLabelBackOffice>>
>;
export type PrintLabelBackOfficeMutationBody = PrintRequest;
export type PrintLabelBackOfficeMutationError = ErrorType<LabelGeneratorError | void>;

/**
 * @summary Print label (Back Office)
 */
export const usePrintLabelBackOffice = <
  TError = ErrorType<LabelGeneratorError | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof printLabelBackOffice>>,
    TError,
    { data: PrintRequest },
    TContext
  >;
}) => {
  const mutationOptions = getPrintLabelBackOfficeMutationOptions(options);

  return useMutation(mutationOptions);
};
